/* Visible product cards outside the custom collection adapter. */
(function () {
  'use strict';
  var api = window.__ga4Journey, config = window.__ga4JourneyConfig || {};
  if (!api) return;
  var lists = new Map(), cards = new Map();
  function rootFor(card) { return card.closest('[data-yml-track], product-recommendations, [data-product-recommendations], [id^="shopify-section-"]') || card.parentElement; }
  function listName(root) {
    if (root.querySelector('template[data-ga4-component="gift_featured_products"]')) return 'gift_featured_products';
    if (root.matches('[data-yml-track]')) return 'you_may_like';
    if (root.closest('[data-product-recommendations], [data-section-type="product-recommendations"]')) return 'related_products';
    return config.pageType === 'collection' ? 'collection_grid' : (config.pageType === 'search' ? 'search_results' : 'featured_products');
  }
  function eligible(card) { return !card.closest('[data-ph-collection-grid], [data-ga4-collection-grid], [id^="QuickShop"], [data-search-results]'); }
  function emit(name, card) {
    var root = cards.get(card), list = root && lists.get(root);
    if (!list || !api.isAllowed()) return false;
    var data = card.dataset, price = data.ga4Price === undefined ? NaN : Number(data.ga4Price) / 100;
    if (!data.productId || !isFinite(price) || !config.currency) { api.noteSkipped(name, 'missing_card_data'); return false; }
    var item = { item_id: data.productId, item_name: data.ga4Title || 'unnamed', product_handle: data.productHandle || 'unknown',
      price: price, quantity: 1, item_list_id: list.name, index: list.cards.indexOf(card) + 1 };
    var payload = { item_list_id: list.name, list_instance_id: list.id, currency: config.currency, items: [item] };
    if (window.__pdp && window.__pdp.product) payload.source_product_id = String(window.__pdp.product.id);
    return api.emit(name, payload);
  }
  function visible(entry) {
    var el = entry.target;
    if (!api.isAllowed() || document.visibilityState === 'hidden' || !entry.isIntersecting || entry.intersectionRatio < 0.5 || el.closest('[inert], [hidden], [aria-hidden="true"]') || getComputedStyle(el).visibility === 'hidden') return;
    for (var node = el; node && node.nodeType === 1; node = node.parentElement) {
      var style = getComputedStyle(node);
      if (style.display === 'none' || style.visibility === 'hidden' || style.visibility === 'collapse' || Number(style.opacity) === 0) return;
    }
    var list = lists.get(cards.get(el));
    if (!list) return;
    var key = el.dataset.productId + ':' + list.cards.indexOf(el);
    if (!list.seen.has(key) && emit('view_item_list', el)) list.seen.add(key);
  }
  var observer = window.IntersectionObserver && new IntersectionObserver(function (entries) { entries.forEach(visible); }, { threshold: [0, 0.5, 1] });
  function scan() {
    var groups = new Map();
    document.querySelectorAll('[data-ga4-product-card]').forEach(function (card) {
      if (!eligible(card)) return;
      var root = rootFor(card);
      if (!groups.has(root)) groups.set(root, []);
      groups.get(root).push(card);
    });
    cards.forEach(function (_, card) { if (!card.isConnected || !eligible(card)) { if (observer) observer.unobserve(card); cards.delete(card); } });
    lists.forEach(function (_, root) { if (!groups.has(root)) lists.delete(root); });
    groups.forEach(function (elements, root) {
      var signature = elements.map(function (card) { return [card.dataset.productId, card.dataset.ga4Price, card.dataset.ga4Title].join(':'); }).join('|') + location.search;
      var state = lists.get(root);
      if (!state || state.signature !== signature) {
        state = { id: api.uuid(), signature: signature, name: listName(root), cards: elements, seen: new Set() };
        lists.set(root, state);
      } else state.cards = elements;
      elements.forEach(function (card) {
        cards.set(card, root);
        if (observer) { observer.unobserve(card); observer.observe(card); }
      });
    });
  }
  document.addEventListener('click', function (event) {
    var link = event.target.closest && event.target.closest('a[href]'), card = link && link.closest('[data-ga4-product-card]');
    if (card && eligible(card) && !event.target.closest('button, input, select')) emit('select_item', card);
  }, true);
  document.addEventListener('wishlist:item-changed', function (event) {
    if (!api.isAllowed()) return;
    var detail = event.detail || {}, p = detail.item;
    if (!p || !p.productId || !p.variantId || !config.currency || ['add', 'remove'].indexOf(detail.action) < 0 || !isFinite(Number(p.price))) return;
    var product = { item_id: String(p.productId), item_variant: String(p.variantId), item_name: p.title || 'unnamed', price: Number(p.price) / 100, quantity: 1 };
    if (detail.action === 'add') api.emit('add_to_wishlist', { currency: config.currency, value: product.price, items: [product] });
    // 自定义取消收藏事件不会编码 items，使用显式商品字段保留真实状态变化。
    else api.emit('remove_from_wishlist', { currency: config.currency, value: product.price, product_id: product.item_id,
      variant_id: product.item_variant, product_title: product.item_name, price: product.price, quantity: 1 });
  });
  function reset() { lists.clear(); scan(); }
  api.onConsent(reset); api.onPageView(reset);
  document.addEventListener('visibilitychange', function () { if (document.visibilityState !== 'hidden') scan(); });
  var scheduled = false;
  new MutationObserver(function () {
    if (scheduled) return;
    scheduled = true; requestAnimationFrame(function () { scheduled = false; scan(); });
  }).observe(document.body, { subtree: true, childList: true, attributes: true, attributeFilter: ['class', 'style', 'hidden', 'inert', 'aria-hidden', 'data-product-id', 'data-ga4-price', 'data-ga4-title'] });
  scan();
  api.registerModule('catalog', function () { return { lists: lists.size, cards: cards.size, observerAvailable: !!observer }; });
})();
